import React from 'react';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import { FadeInDownAnimation } from '../../../styles/FadeInDownAnimation';
import { GREETING_DURATION_IN_MS } from '../constants';
import { Accent } from '../../../src/atoms/Typography';
export const HEIGHT_TRIANGLE_IN_REM = 0.625;
const WIDTH_TRIANGLE_IN_REM = 0.875;
const SHADOW_WIDTH_IN_REM = 0.125;
const Wrapper = styled.span `
  align-items: center;
  background-color: ${props => props.theme.White};
  border-radius: 2.125rem;
  display: flex;
  flex-direction: row;
  min-height: 3.125rem;
  padding-left: 0.875rem;
  margin-right: ${SHADOW_WIDTH_IN_REM}rem;
  padding-right: 1rem;
  /* Reference for triangle */
  position: relative;
  box-shadow: 0 0.125rem 0 0 ${props => props.theme.GrayLighter};

  /* Triangle above the bubble */
  &:before {
    border: ${HEIGHT_TRIANGLE_IN_REM}rem solid ${props => props.theme.White};
    border-top: 0;
    border-left: ${WIDTH_TRIANGLE_IN_REM / 2}rem solid transparent;
    border-right: ${WIDTH_TRIANGLE_IN_REM / 2}rem solid transparent;
    content: '';
    position: absolute;
    top: -${HEIGHT_TRIANGLE_IN_REM}rem;
    right: 1.75rem;
  }

  animation: ${FadeInDownAnimation} ${GREETING_DURATION_IN_MS}ms;
  /* fix Chrome flackering on animation end */
  animation-fill-mode: forwards;
`;
const StyledAccent = styled(Accent) `
  font-size: 1.25rem;
  line-height: 1.25rem;
  margin-left: 0.625rem;
`;
const Name = styled.span `
  color: ${props => props.theme.Gray};
  font-size: 0.875rem;
  line-height: 1.29;
  white-space: nowrap;

  &:not(:empty) {
    margin-left: 0.5rem;
  }
`;
const WavingHand = () => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1.9375rem", height: "2rem", viewBox: "0 0 28 28" },
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("path", { d: "M23.04 7.907c0-1.165-.93-2.109-2.077-2.109-1.147 0-2.077.944-2.077 2.109v2.181l-5.628-5.713c-.704-.713-1.844-.713-2.547 0-.703.714-.703 1.871 0 2.585L9.426 5.655c-.703-.713-1.843-.713-2.547 0-.703.714-.703 1.871 0 2.585l.745.756c-.704-.714-1.844-.714-2.547 0-.703.713-.703 1.87 0 2.584l1.837 1.865c-.703-.714-1.843-.714-2.547 0-.703.713-.703 1.87 0 2.584l5.67 5.755c2.91 2.955 7.629 2.955 10.539 0l.73-.741c1.156-1.173 1.734-2.711 1.734-4.249V7.907z", fill: "#FDE47F", transform: "rotate(-10 23.944 1.637)" }),
        React.createElement("path", { d: "M11.128 4.12c-.098 0-.197-.034-.272-.102L7.108.636c-.151-.135-.151-.356 0-.492.15-.136.394-.136.545 0l3.748 3.382c.15.135.15.356 0 .492-.075.068-.174.102-.273.102zM8.437 6.627c-.098 0-.197-.034-.272-.102L3.79 2.579c-.15-.136-.15-.356 0-.492s.395-.136.546 0L8.71 6.033c.15.135.15.356 0 .492-.075.068-.174.102-.273.102zM6.187 9.53c-.099 0-.198-.033-.273-.101L3.029 6.826c-.15-.136-.15-.356 0-.492s.395-.136.545 0L6.46 8.937c.151.136.151.356 0 .492-.075.068-.174.102-.272.102z", fill: "#FAC800", transform: "rotate(-10 23.944 1.637) translate(2.88 6.72)" }),
        React.createElement("path", { d: "M2.021 4.536c-.205-.873-.892-1.554-1.75-1.734C.11 2.768.006 2.606.039 2.44c.033-.166.192-.274.354-.24 1.085.228 1.953 1.089 2.213 2.193.038.165-.06.331-.222.371-.16.04-.323-.061-.362-.227zM4.194 4.328C3.754 2.455 2.28.995.44.609.278.575.173.413.207.246.24.08.398-.028.56.006 2.627.44 4.282 2.08 4.777 4.184c.039.165-.06.331-.221.371-.161.04-.323-.061-.362-.227z", fill: "#333", transform: "rotate(-10 23.944 1.637) translate(14.4)" }),
        React.createElement("path", { d: "M4.392 2.59C3.288 2.33 2.428 1.462 2.2.377c-.034-.162.073-.32.24-.354.166-.033.329.072.363.234.18.858.86 1.544 1.733 1.75.166.039.267.2.227.362-.04.16-.206.26-.37.221zM4.184 4.762C2.08 4.268.44 2.612.007.546-.027.384.08.226.247.192.412.16.575.264.61.426c.386 1.84 1.846 3.313 3.718 3.753.166.039.267.2.227.362-.04.161-.205.26-.37.221z", fill: "#333", transform: "rotate(-10 23.944 1.637) translate(0 18.24)" }),
        React.createElement("path", { d: "M17.345 18.24c-.175 0-.342-.067-.416-.18-.955-1.454-.779-3.128.473-4.477.13-.14.408-.185.622-.1.213.087.28.27.15.411-1.098 1.184-1.253 2.653-.415 3.929.1.151-.006.327-.235.392-.058.017-.12.025-.18.025z", fill: "#FAC800", transform: "rotate(-10 23.944 1.637)" }))));
export const GreetingBubble = ({ className, children = null, }) => (React.createElement(Wrapper, { className: className },
    React.createElement(WavingHand, null),
    React.createElement(Trans, { i18nKey: "MainNavigation:Greeting" },
        React.createElement(StyledAccent, { color: "primary" }, "Hallo"),
        React.createElement(Name, null, children))));
